import LoginForm from './login-form';
import FormTitle from './form-title';

export { FormTitle };
export default LoginForm;